"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.useInterval = function (callback, delay) {
    var savedCallback = React.useRef();
    React.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    React.useEffect(function () {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
};
//# sourceMappingURL=index.js.map